import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Spinner, Badge, Card } from "react-bootstrap";

const OrderHistory = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const userId = localStorage.getItem("customer_id");

    useEffect(() => {
        const fetchOrders = async () => {
            if (!userId) {
                console.error("User ID not found in localStorage.");
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/orders?customer_id=${userId}`
                );

                // ✅ Only completed orders
                const completedOrders = (response.data.data || []).filter(
                    (order) => order.status === "completed"
                );

                setOrders(completedOrders);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [userId]);

    return (
        <Container className="my-5">
            <h2 className="mb-4 text-center">My Completed Orders</h2>

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : orders.length === 0 ? (
                <p className="text-muted text-center">No completed orders found.</p>
            ) : (
                <div className="d-flex flex-column gap-3">
                    {orders.map((order) => (
                        <Card key={order.order_id} className="shadow-sm border-0 rounded-3">
                            <Card.Body className="d-flex justify-content-between align-items-center">
                                {/* Left side: Service + Package */}
                                <div>
                                    <h5 className="mb-1 text-primary fw-bold">{order.service_name}</h5>
                                    <small className="text-muted">Package: {order.package_type}</small>
                                </div>

                                {/* Middle: Transaction + Date */}
                                <div className="text-center d-none d-md-block">
                                    <div className="small text-muted">
                                        <strong>Transaction:</strong> {order.transaction_id}
                                    </div>
                                    <div className="small">
                                        {new Date(order.order_date).toLocaleDateString()}
                                    </div>
                                </div>

                                {/* Right side: Amount + Status */}
                                <div className="text-end">
                                    <div className="fw-bold text-success mb-1">
                                        ৳{parseFloat(order.total_amount).toFixed(2)}
                                    </div>
                                    <p className="text-success">Completed</p>
                                </div>
                            </Card.Body>
                        </Card>
                    ))}
                </div>
            )}
        </Container>
    );
};

export default OrderHistory;
